import { useState } from 'react';
import { categories } from '@/mocks/categories';

const categoryCardImages: Record<string, string> = {
  'cat-shoes-2026': 'https://readdy.ai/api/search-image?query=Clean%20minimal%20sneakers%20on%20warm%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20terracotta%20and%20neutral%20background%2C%20minimal%20shadow%2C%20high%20detail%20leather%20texture&width=400&height=300&seq=card-shoes-new-2026&orientation=landscape',
  'cat-hoodies-2026': 'https://readdy.ai/api/search-image?query=Stylish%20hoodie%20folded%20on%20warm%20beige%20background%2C%20soft%20daylight%2C%20editorial%20fashion%20photography%2C%20minimal%20aesthetic%2C%20earthy%20neutral%20tones%2C%20high%20detail%20fabric%20texture&width=400&height=300&seq=card-hoodies-new-2026&orientation=landscape',
  'cat-tshirts-2026': 'https://readdy.ai/api/search-image?query=Clean%20graphic%20t-shirt%20flat%20lay%20on%20warm%20cream%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20neutral%20and%20sage%20green%20accents&width=400&height=300&seq=card-tshirts-new-2026&orientation=landscape',
  'cat-jackets-2026': 'https://readdy.ai/api/search-image?query=Elegant%20denim%20jacket%20displayed%20on%20warm%20cream%20background%2C%20soft%20daylight%2C%20editorial%20fashion%20photography%2C%20minimal%20shadow%2C%20neutral%20earthy%20tones%2C%20high%20detail%20textile&width=400&height=300&seq=card-jackets-new-2026&orientation=landscape',
  'cat-pants-2026': 'https://readdy.ai/api/search-image?query=Stylish%20jeans%20and%20shorts%20flat%20lay%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20minimal%20shadow%2C%20neutral%20tonal%20palette&width=400&height=300&seq=card-pants-new-2026&orientation=landscape',
  'cat-headwear-2026': 'https://readdy.ai/api/search-image?query=Trendy%20baseball%20caps%20arranged%20on%20warm%20cream%20background%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20neutral%20and%20coral%20accents&width=400&height=300&seq=card-headwear-new-2026&orientation=landscape',
  'cat-sets-2026': 'https://readdy.ai/api/search-image?query=Matching%20outfit%20set%20flat%20lay%20on%20warm%20terracotta%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20minimal%20shadow%2C%20earthy%20warm%20tones&width=400&height=300&seq=card-sets-new-2026&orientation=landscape',
  'cat-underwear-2026': 'https://readdy.ai/api/search-image?query=Neatly%20folded%20socks%20and%20underwear%20on%20warm%20cream%20surface%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20clean%20neutral%20aesthetic&width=400&height=300&seq=card-underwear-new-2026&orientation=landscape',
  'cat-jersey-2026': 'https://readdy.ai/api/search-image?query=Sports%20jersey%20displayed%20on%20warm%20beige%20background%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20minimal%20shadow%2C%20clean%20athletic%20aesthetic&width=400&height=300&seq=card-jersey-new-2026&orientation=landscape',
  'cat-accessories-2026': 'https://readdy.ai/api/search-image?query=Elegant%20sunglasses%20and%20fashion%20accessories%20on%20warm%20cream%20surface%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20neutral%20and%20gold%20accents&width=400&height=300&seq=card-accessories-new-2026&orientation=landscape',
  'cat-bags-2026': 'https://readdy.ai/api/search-image?query=Stylish%20backpack%20and%20handbag%20on%20warm%20terracotta%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20fashion%20photography%2C%20minimal%20shadow%2C%20earthy%20neutral%20tones&width=400&height=300&seq=card-bags-new-2026&orientation=landscape',
  'cat-belts-2026': 'https://readdy.ai/api/search-image?query=Elegant%20leather%20belts%20displayed%20on%20warm%20cream%20background%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20neutral%20luxury%20aesthetic&width=400&height=300&seq=card-belts-new-2026&orientation=landscape',
  'cat-perfumes-2026': 'https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20arranged%20on%20warm%20beige%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20gold%20and%20cream%20tones&width=400&height=300&seq=card-perfumes-new-2026&orientation=landscape',
  'cat-other-2026': 'https://readdy.ai/api/search-image?query=Miscellaneous%20fashion%20items%20and%20lifestyle%20products%20on%20warm%20cream%20surface%2C%20soft%20daylight%2C%20editorial%20product%20photography%2C%20minimal%20shadow%2C%20earthy%20neutral%20tones&width=400&height=300&seq=card-other-new-2026&orientation=landscape',
};

export default function CategorySection() {
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,nofollow');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 mb-14">
          <div className="relative rounded-2xl overflow-hidden aspect-[4/3]">
            <img
              src="https://readdy.ai/api/search-image?query=Diverse%20fashion%20and%20streetwear%20products%20arranged%20in%20a%20clean%20grid%20on%20warm%20cream%20background%2C%20sneakers%20hoodies%20and%20accessories%20displayed%20neatly%2C%20soft%20diffused%20daylight%2C%20editorial%20product%20photography%2C%20earthy%20neutral%20tones%2C%20high%20detail&width=800&height=600&seq=cat-display-new-2026&orientation=landscape"
              alt="Browse all Sugargoo Spreadsheet categories"
              title="Sugargoo Spreadsheet Categories - Shoes Hoodies T-Shirts and more"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute top-4 left-4 flex gap-2">
              {['Shoes', 'Hoodies', 'New'].map((tag) => (
                <span
                  key={tag}
                  className="bg-background-50/80 backdrop-blur-sm text-foreground-950 text-xs font-semibold px-3 py-1 rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
          <div className="flex flex-col justify-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-5">
              Browse All Categories
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-5">
              Our Sugargoo spreadsheet covers every product category you need. From sneakers and
              streetwear to accessories and bags, find curated product links organized for quick
              access.
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {categories.slice(0, 5).map((cat) => (
                <a
                  key={cat.name}
                  href={cat.url}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-xs font-semibold text-foreground-700 bg-background-50 border border-background-200/60 px-3 py-1.5 rounded-full hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all cursor-pointer whitespace-nowrap"
                >
                  {cat.name}
                </a>
              ))}
              <span className="text-xs font-semibold text-foreground-500 px-3 py-1.5">+9 more</span>
            </div>
            <div className="bg-foreground-950 rounded-2xl p-6 md:p-8 text-background-50">
              <span className="text-xs font-bold uppercase tracking-wider text-accent-400 mb-3 block">
                Quick Links
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-bold mb-3">
                Instant Access to All Product Categories
              </h3>
              <p className="text-foreground-300 text-sm leading-relaxed mb-4">
                Select any category from the dropdown below to jump directly to the product listings.
              </p>
              <div className="relative">
                <select
                  value={selectedCategory}
                  onChange={handleDropdownChange}
                  className="w-full h-12 bg-foreground-800 border border-foreground-700 rounded-xl px-4 pr-10 text-sm text-background-50 appearance-none cursor-pointer focus:outline-none focus:border-accent-500 transition-colors"
                >
                  <option value="">Select a Category...</option>
                  {categories.map((cat) => (
                    <option key={cat.name} value={cat.url}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                <span className="absolute right-3 top-1/2 -translate-y-1/2 text-background-50 pointer-events-none w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-down-s-line text-lg"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-8">
          <h3 className="font-heading text-xl font-bold text-foreground-950 mb-5 text-center">
            All Product Categories
          </h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group flex flex-col items-center gap-2 p-3 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer"
              >
                <div className="w-full aspect-square rounded-lg overflow-hidden bg-background-200/50">
                  <img
                    src={categoryCardImages[cat.imageSeq]}
                    alt={`${cat.name} - Sugargoo Spreadsheet`}
                    title={`Sugargoo Spreadsheet ${cat.name}`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <span className="text-xs font-semibold text-foreground-800 text-center leading-tight whitespace-nowrap">
                  {cat.name}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}